module.exports = __webpack_public_path__ + "static/media/au-varna.fb59b623.png";